import { render, staticRenderFns } from "./TrainingCreateDropdown.vue?vue&type=template&id=3628ff00&scoped=true&"
import script from "./TrainingCreateDropdown.vue?vue&type=script&lang=js&"
export * from "./TrainingCreateDropdown.vue?vue&type=script&lang=js&"
import style0 from "./TrainingCreateDropdown.vue?vue&type=style&index=0&id=3628ff00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3628ff00",
  null
  
)

export default component.exports